import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { SmartOrpcClientService } from './shared/services/smart-orpc-client.service';
import {
  downloadBlobWithAnchor,
  downloadUrlWithIframe,
} from './shared/utils/file-download';

type ReportTemplateId = 'compliance' | 'harvestHistory';
@Injectable({
  providedIn: 'root',
})
export class QgisService {
  orpc = inject(SmartOrpcClientService);
  http = inject(HttpClient);

  /** Gera URL para PDF gerado diretamente pelo motor de template de Atlas do QGIS */
  getReportAtlasPrintUrl(template: ReportTemplateId, pk: number) {
    const params = new URLSearchParams({
      SERVICE: 'WMS',
      VERSION: '1.3.0',
      REQUEST: 'GetPrint',
      CRS: 'EPSG:4674',
      FORMAT: 'pdf',
      FORMAT_OPTIONS: 'TEXT_RENDER_FORMAT:AlwaysText',
      TEMPLATE:
        template == 'compliance'
          ? 'layoutDataSafra__Compliance'
          : 'layoutDataSafra__histSafras',
      DPI: '96', //TODO: aumentar DPI quando os pdfs nao forem mais gerados sob demanda (no backend)
      ATLAS_PK: pk.toString(),
    });

    return `${environment.QGIS_PATH}/?${params.toString()}`;
  }

  /** Baixa relatório gerado pelo motor de template Handlebars (HTML+QGIS), usa GetMap internamente ao invés de GetPrint */
  async downloadComplianceReport(pk: number): Promise<void> {
    const { downloadUrl } = await this.orpc.client.qgis.getComplianceReport({
      complianceId: pk,
      actionType: 'download',
    });
    try {
      downloadUrlWithIframe(downloadUrl);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  }

  async downloadHarvestHistoryReport(pk: number, territoryId: string) {
    const downloadUrl = this.getReportAtlasPrintUrl('harvestHistory', pk);

    try {
      const blob = await firstValueFrom(
        this.http.get(downloadUrl, { responseType: 'blob' }),
      );
      downloadBlobWithAnchor(
        blob,
        `relatorio-harvestHistory-area-${territoryId}-${pk}.pdf`,
      );
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  }

  async openFileInNewTab(pk: number): Promise<void> {
    const { downloadUrl } = await this.orpc.client.qgis.getComplianceReport({
      complianceId: pk,
      actionType: 'open',
    });

    try {
      window.open(downloadUrl, '_blank');
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  }
}
